import { Link, Outlet } from 'react-router-dom'

export default function Header({ isLogin, setIsLogin }) {
    return <>
        <div className='header'>
            <h1><Link to="https://www.mrhussain.in/portfolio/github-explore/">Git Repositiry</Link></h1>
            <ul>
                <li><Link to="https://www.mrhussain.in/portfolio/github-explore/" >Home</Link></li>
                <li><Link to="https://www.mrhussain.in/portfolio/github-explore/users" >Users</Link></li>
                <li><Link to="https://www.mrhussain.in/portfolio/github-explore/search" >Search</Link></li>
                {/* <li><Link to="/authprofile" >Profile</Link></li> */}
                <li>
                    {isLogin ?
                        <Link to="https://www.mrhussain.in/portfolio/github-explore/login" onClick={() => setIsLogin(false)} >Logout</Link> :
                        <Link to="https://www.mrhussain.in/portfolio/github-explore/login" >Login</Link>}

                </li>
            </ul>
        </div>
        <Outlet />
    </>
}